"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightClient = void 0;
const openapi_1 = require("./generated-sources/openapi");
const core_client_1 = require("@deliverr/core-client");
class FreightClient extends core_client_1.OpenApiGeneratedClient {
    constructor(config = { authEngine: core_client_1.AuthEngine.BASIC }) {
        super(config);
    }
    getDefaultServiceUrlEnvKey() {
        return FreightClient.SERVICE_URL_ENV_KEY;
    }
    instantiateOpenApiGeneratedApi() {
        return new openapi_1.ServiceApi(new openapi_1.Configuration(this.getConfigurationParameters()));
    }
    async getOrderDetails(orderId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const orderResponse = await this.getOpenApiGeneratedApi().getOrderV1(orderId, sellerId);
            return orderResponse.data;
        });
    }
    async getOrders(sellerId, limit, cursor, direction) {
        return await this.wrapClientOperationExecution(async () => {
            const orderResponse = await this.getOpenApiGeneratedApi().getOrdersV1(sellerId, limit, cursor, direction);
            return orderResponse.data;
        });
    }
    async getBol(orderId, bolId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const orderResponse = await this.getOpenApiGeneratedApi().getBol(orderId, bolId, sellerId);
            return orderResponse.data;
        });
    }
    async cancelOrder(orderId, cancellationReason, sellerId) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().cancel(orderId, { sellerId, cancellationReason });
        });
    }
    async createOrder(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().create(orderRequest);
            return response.data;
        });
    }
    async createFtlOrder(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createFtl(orderRequest);
            return response.data;
        });
    }
    async createLtlOrder(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createLtl(orderRequest);
            return response.data;
        });
    }
    async getOrderDetailsV2(orderId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const orderResponse = await this.getOpenApiGeneratedApi().getOrder(orderId, sellerId);
            return orderResponse.data;
        });
    }
    async getOrdersV2(sellerId, limit, cursor, direction) {
        return await this.wrapClientOperationExecution(async () => {
            const orderResponse = await this.getOpenApiGeneratedApi().getOrders(sellerId, limit, cursor, direction);
            return orderResponse.data;
        });
    }
    async createFclOrder(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createFclOrder(orderRequest);
            return response.data;
        });
    }
    async createDrayageOrderV2(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createDrayageOrder(orderRequest);
            return response.data;
        });
    }
    async createFtlOrderV2(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createFtlOrder(orderRequest);
            return response.data;
        });
    }
    async createLtlOrderV2(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createLtlOrder(orderRequest);
            return response.data;
        });
    }
    async getOrderDocuments(orderId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getOrderDocuments(orderId, sellerId);
            return response.data;
        });
    }
    async createDrayageOrder(orderRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createDrayage(orderRequest);
            return response.data;
        });
    }
    async getQuoteByQuoteId(quoteId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuoteV1(quoteId, sellerId);
            return quoteResponse.data;
        });
    }
    async getQuotes(sellerId, limit, offset) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuotesV1(sellerId, limit, offset);
            return quoteResponse.data;
        });
    }
    async getQuoteRequests(sellerId, limit, offset) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuoteRequests(sellerId, limit, offset);
            return quoteResponse.data;
        });
    }
    async getQuoteRequestById(quoteRequestId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuoteRequestById(quoteRequestId, sellerId);
            return quoteResponse.data;
        });
    }
    async generateQuote(quoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().generateQuote(quoteRequest);
            return quoteResponse.data;
        });
    }
    async generateQuotes(requestForQuote) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().generateQuotes(requestForQuote);
            return quoteResponse.data;
        });
    }
    async generateFtlQuote(ftlQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().generateFtlQuoteV2(ftlQuoteRequest);
            return quoteResponse.data;
        });
    }
    async generateLtlQuote(ltlQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().generateLtlQuoteV2(ltlQuoteRequest);
            return quoteResponse.data;
        });
    }
    async generateLtlBatchQuote(ltlBatchQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().generateLtlBatchQuote(ltlBatchQuoteRequest);
            return quoteResponse.data;
        });
    }
    async getQuoteByQuoteIdV2(quoteId, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuote(quoteId, sellerId);
            return quoteResponse.data;
        });
    }
    async getQuotesV2(sellerId, limit, offset, cursor, direction) {
        return await this.wrapClientOperationExecution(async () => {
            const quoteResponse = await this.getOpenApiGeneratedApi().getQuotes(sellerId, limit, offset, cursor, direction);
            return quoteResponse.data;
        });
    }
    async generateIntlQuote(intlOceanQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const intlOceanQuoteResponse = await this.getOpenApiGeneratedApi().generateIntlOceanQuote(intlOceanQuoteRequest);
            return intlOceanQuoteResponse.data;
        });
    }
    async generateDrayageQuoteV2(drayageQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const drayageQuoteResponse = await this.getOpenApiGeneratedApi().generateDrayageQuote(drayageQuoteRequest);
            return drayageQuoteResponse.data;
        });
    }
    async generateFtlQuoteV2(ftlQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const ftlQuoteResponse = await this.getOpenApiGeneratedApi().generateFtlQuote(ftlQuoteRequest);
            return ftlQuoteResponse.data;
        });
    }
    async generateLtlQuoteV2(ltlQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const ltlQuoteResponse = await this.getOpenApiGeneratedApi().generateLtlQuote(ltlQuoteRequest);
            return ltlQuoteResponse.data;
        });
    }
    async updateLegByShipmentId(freightShipmentId, updateLegRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updateByShipmentId(freightShipmentId, updateLegRequest);
            return response.data;
        });
    }
    async getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId);
            return response.data;
        });
    }
    async getOrderItemByShipmentId(freightShipmentId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getOrderItemByShipmentId(freightShipmentId);
            return response.data;
        });
    }
    async createWarehouseLoadingDockScanEvent(loadingDockScanEventRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createWarehouseLoadingDockScanEvent(loadingDockScanEventRequest);
            return response.data;
        });
    }
    async createAddressLoadingDockScanEvent(loadingDockScanEventRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createAddressLoadingDockScanEvent(loadingDockScanEventRequest);
            return response.data;
        });
    }
    async getCustomer(sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getCustomer(sellerId);
            return response.data;
        });
    }
    async upsertCustomer(customer) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().upsertCustomer(customer);
            return response.data;
        });
    }
    async getRecentlyUsedAddresses(sellerId, pickup) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getRecentlyUsedAddresses(sellerId, pickup);
            return response.data;
        });
    }
    async getBolTracking(bolId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getBolTracking(bolId);
            return response.data;
        });
    }
    async getCustomers(sellerIds) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getCustomersV2(sellerIds);
            return response.data;
        });
    }
    async backfillShipment(backfillShipmentRequest) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().backfillShipment(backfillShipmentRequest);
        });
    }
    async backfillDrayload(backfillDrayloadRequest) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().backfillDrayload(backfillDrayloadRequest);
        });
    }
    async backfillAccessorialOrderItems(backfillAccessorialOrderItemRequest) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().backfillAccessorialOrderItems(backfillAccessorialOrderItemRequest);
        });
    }
    async getExistingLegByShipmentId(freightShipmentId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getExistingLegByShipmentId(freightShipmentId);
            return response.data;
        });
    }
    async getAllProfilesBySellerId(sellerId, status) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getAllProfilesBySellerId(sellerId, status);
            return response.data;
        });
    }
    async getTradingPartnerBookingFields(tradingPartner, mode) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getTradingPartnerBookingFields(tradingPartner, mode);
            return response.data;
        });
    }
    async getWarehousesByAddressAndCapabilities(address, capabilities) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getWarehousesByAddressAndCapabilities({
                address,
                capabilities,
            });
            return response.data;
        });
    }
    async getAllPorts() {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getAllPorts();
            return response.data;
        });
    }
    async getPort(portId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getPort(portId);
            return response.data;
        });
    }
    async getSellerPricingStrategiesAndRates(sellerId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getSellerPricingStrategiesAndRates(sellerId);
            return response.data;
        });
    }
    async getContainerFreightStation(containerFreightStationId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getContainerFreightStationV1(containerFreightStationId);
            return response.data;
        });
    }
    async getContainerFreightStations(limit, cursor, direction) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getContainerFreightStationsV1(cursor, limit, direction);
            return response.data;
        });
    }
    async createContainerFreightStation(containerFreightStationData) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createContainerFreightStationV1(containerFreightStationData);
            return response.data;
        });
    }
    async updateContainerFreightStation(containerFreightStationId, containerFreightStationData) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updateContainerFreightStationV1(containerFreightStationId, containerFreightStationData);
            return response.data;
        });
    }
    async deleteContainerFreightStation(containerFreightStationId) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().deleteContainerFreightStationV1(containerFreightStationId);
        });
    }
    async createFreightTrackingInfo(sellerId, freightTrackingInfoData) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().createFreightTrackingInfo(sellerId, freightTrackingInfoData);
            return data;
        });
    }
    async getFreightTrackingInfo(sellerId, externalIdType, externalId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getFreightTrackingInfo(sellerId, externalIdType, externalId);
            return data;
        });
    }
    async updateOrCreateFreightTrackingInfo(sellerId, trackingDataWithUpdates) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().updateOrCreateFreightTrackingInfo(sellerId, trackingDataWithUpdates);
            return data;
        });
    }
    async getBolPdfUrl(bolId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getBolPdfUrl(bolId);
            return data;
        });
    }
    async generateFreightQuote(freightQuoteRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().generateFreightQuote(freightQuoteRequest);
            return data;
        });
    }
    async getPlan(freightPlanId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getPlan(freightPlanId);
            return data;
        });
    }
    async getPublicPlan(freightPlanId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getPlanFromHashId(freightPlanId);
            return data;
        });
    }
    async generateFreightPlanHashId(freightPlanId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().generateFreightPlanHashId(freightPlanId);
            return data;
        });
    }
    async generatePalletLabels(sellerId, shippingPlanId, language, paperSize) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().generatePalletLabels(sellerId, shippingPlanId, language, paperSize);
            return data;
        });
    }
    async getBolTrackingByBolId(bolId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getBolTrackingByBolId(bolId);
            return data;
        });
    }
    async getEligibleFreightStrategies(eligibleFreightStrategyRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getEligibleFreightStrategies(eligibleFreightStrategyRequest);
            return data;
        });
    }
    async getFreightTrackingByBolIds(freightTrackingByBolIdsRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().getFreightTrackingByBolIds(freightTrackingByBolIdsRequest);
            return data;
        });
    }
    async rateShop(freightRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().rateShop(freightRequest);
            return data;
        });
    }
    async dispatchByFreightRateId(freightRateId) {
        return await this.wrapClientOperationExecution(async () => {
            const { data } = await this.getOpenApiGeneratedApi().dispatchByFreightRateId(freightRateId);
            return data;
        });
    }
}
exports.FreightClient = FreightClient;
FreightClient.SERVICE_URL_ENV_KEY = "FREIGHT_SERVICE_URL";
//# sourceMappingURL=FreightClient.js.map